var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"snackbar"}},[(_vm.visible)?_c('div',{staticClass:"snackbar",class:`snackbar--${_vm.type}`},[_vm._v(" "+_vm._s(_vm.message)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }